import gql from "graphql-tag";

export const EMPLOYEE_MApp_ANCHORS = gql`
  query reportingEmployeesMAppAnchors($employeeId: ID!) {
    reportingEmployeesMAppAnchors(employeeId: $employeeId)
  }
`;
